export function humanFileSize(bytes: number): string {
    const thresh = 1024
    if (Math.abs(bytes) < thresh) return bytes + ' B'
    const units = ['KB', 'MB', 'GB', 'TB']
    let u = -1
    let value = bytes
    do {
        value /= thresh
        ++u
    } while (Math.abs(value) >= thresh && u < units.length - 1)
    return value.toFixed(1) + ' ' + units[u]
}

export function areFilesEqual(a: File, b: File): boolean {
    return a.name === b.name && a.size === b.size && a.type === b.type && a.lastModified === b.lastModified
}
